import ky from 'ky-universal';
import { takeLeading, put, call } from 'redux-saga/effects';
import { schema, normalize } from 'normalizr';

import { staticHost } from '../../config/api';

import { drama as dramaActionTypes } from '../constants/actionTypes';
const { FETCH_DRAMA_CATEGORY, FETCH_DRAMA_CATEGORY_SUCCESS, FETCH_DRAMA_CATEGORY_FAILED } = dramaActionTypes;

function* fetchCategory() {
  const abortController = new AbortController();

  try {
    const res = yield call(ky.get, `${staticHost}/api/drama/category.json`, {
      signal: abortController.signal,
    });

    const { data: categories } = yield res.json();

    const categoryEntity = new schema.Entity('categories');
    const normalizedData = normalize(categories, [categoryEntity]);
    
    yield put({
      type: FETCH_DRAMA_CATEGORY_SUCCESS, 
      payload: { normalizedData },
    });
  } catch (error) {
    yield put({ type: FETCH_DRAMA_CATEGORY_FAILED, payload: { error } });
  }
}

export function* fetchCategoryFlow() {
  yield takeLeading(FETCH_DRAMA_CATEGORY, fetchCategory);
}
